import { SOLAR_SELF_CONSUMPTION_FRACTION } from './assumptions';
import { EnergyLoads } from './types';

export type SolarSplit = {
  directKwh: number;
  exportKwh: number;
  importKwh: number;
};

export const consumptionKwhForMonth = (loads: EnergyLoads, month: number): number =>
  loads.baseloadKwh[month] + loads.coolingKwh[month] + loads.heatingKwh[month];

// Intra-month split: a fixed fraction of production is consumed as generated;
// the remainder exports. Imports cover the rest of consumption.
export const splitSolarMonth = (consumptionKwh: number, productionKwh: number): SolarSplit => {
  const directKwh = Math.min(productionKwh * SOLAR_SELF_CONSUMPTION_FRACTION, consumptionKwh);

  return {
    directKwh,
    exportKwh: productionKwh - directKwh,
    importKwh: consumptionKwh - directKwh,
  };
};
